import { RTPWithdrawTransaction } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchRTPWithdrawTransaction({ bearer }: { bearer: string }) {
  const [fetching, setFetching] = useState(false);
  const [rtpWithdrawTransaction, setRTPWithdrawTransaction] = useState<RTPWithdrawTransaction>();

  async function fetchRTPWithdrawTransaction(transactionID: string) {
    try {
      setFetching(true);
      const res = await api.fetchRTPWithdrawTransaction({ TransactionID: transactionID }, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setRTPWithdrawTransaction(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, rtpWithdrawTransaction, fetchRTPWithdrawTransaction };
}
